var _rect, _rect2, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnglishFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 18,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 19,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15569_191412",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 27,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V19H28V1H1Z",
    fill: "#012169"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15569_191412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1V19H28V1H1Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1L28 19ZM28 1L1 19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.835 2.5435L17.6502 10L28.835 17.4565L27.168 20.5435L14.5015 12.0991L1.83496 20.5435L0.167969 17.4565L11.3527 10L0.167969 2.5435L1.83496 -0.543457L14.5015 7.90087L27.168 -0.543457L28.835 2.5435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.3994L3.09914 19H1L14.5 10V11.3994ZM16.5991 10L28 17.6005V19L14.5 10H16.5991ZM14.5 10V8.60055L25.9009 1H28L14.5 10ZM14.5 10H12.4008L1 2.39942V1L14.5 10Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.460938 7.60002H12.3409V0.400024H16.6609V7.60002H28.5409V12.4H16.6609V19.6H12.3409V12.4H0.460938V7.60002Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.198 -0.200073V6.99993H29.078V12.9999H17.198V20.1999H11.798V12.9999H-0.0820312V6.99993H11.798V-0.200073H17.198ZM12.878 8.19993H0.997969V11.7999H12.878V18.9999H16.118V11.7999H27.998V8.19993H16.118V0.999927H12.878V8.19993Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishFlag);
export default __webpack_public_path__ + "static/media/englishFlag.355219a44ccf1ca894959bd445f7fe35.svg";
export { ForwardRef as ReactComponent };